import { lazy, type ComponentType, type LazyExoticComponent } from "react";

export const STALE_CHUNK_RELOAD_KEY = "disciplio:stale-chunk-reload";

const staleChunkPatterns = [
  "failed to fetch dynamically imported module",
  "importing a module script failed",
  "expected a javascript-or-wasm module script",
  "loading chunk",
  "chunkloaderror",
];

export function toError(value: unknown): Error {
  if (value instanceof Error) return value;
  if (typeof value === "string") return new Error(value);

  try {
    return new Error(JSON.stringify(value));
  } catch {
    return new Error("Unknown application error");
  }
}

export function isStaleChunkError(value: unknown): boolean {
  const error = toError(value);
  const message = `${error.name} ${error.message}`.toLowerCase();
  return staleChunkPatterns.some((pattern) => message.includes(pattern));
}

export function markStaleChunkReloadAttempt(): void {
  sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, "1");
}

export function hasStaleChunkReloadAttempt(): boolean {
  return sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY) === "1";
}

export function markApplicationBooted(): void {
  sessionStorage.removeItem(STALE_CHUNK_RELOAD_KEY);
}

export function latestVersionUrl(href: string, timestamp = Date.now()): string {
  const url = new URL(href);
  url.searchParams.set("_reload", timestamp.toString());
  return url.toString();
}

export function reloadLatestVersion(): void {
  window.location.replace(latestVersionUrl(window.location.href));
}

export function lazyRoute<T extends ComponentType<unknown>>(
  loader: () => Promise<{ default: T }>
): LazyExoticComponent<T> {
  return lazy(async () => {
    const module = await loader();
    markApplicationBooted();
    return module;
  });
}
